import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import { type Movie } from "src/lib/movieinfo/movieinfotypes";
import styles from './MoviePosterImage.module.css';
import classNames from 'classnames';

//#region [Props]
type MoviePosterImageProps = {
	movie: Movie;
	className?: string;
	missingPosterOffCentre?: boolean;
};
//#endregion

//#region [Component]
export default function MoviePosterImage({ movie, className, missingPosterOffCentre = false}: MoviePosterImageProps) {
    return <div className={classNames(styles.SPosterSizer, className)}>
        {movie.sanityImagePosterUrl &&
            <CmsImageForUrl imageUrl={movie.sanityImagePosterUrl} alt={`Plakat for ${movie.title}`}/>
        }
        {!movie.sanityImagePosterUrl && <div data-postermissingtext="Plakat mangler" className={classNames(styles.SMissingPoster, {
            [styles.offCentre]: missingPosterOffCentre
        })}>
            {movie.title}
        </div>}
    </div>;
}
//#endregion

//#region [Styles]
// Moved to MoviePosterImage.module.css
//#endregion
